export interface EntityIndicador {
  id: string;
  titulo: string;
  valorMinimo: number;
  valorMaximo: number;
  reverso: boolean;
  exibir: boolean;
  exibirPercentuais?: boolean;
}

export const emptyIndicador = (): EntityIndicador => ({
  id: '',
  titulo: '',
  valorMinimo: 0,
  valorMaximo: 0,
  reverso: false,
  exibir: true,
});
